import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BillingCancel() {
  return (
    <div className="fade-up flex items-center justify-center py-16">
      <div className="max-w-md w-full p-8 rounded-2xl bg-[#0D2038] border border-[#1F3A5C] text-center">
        <XCircle className="w-12 h-12 text-[#AAB7C7] mx-auto" />
        <h1 className="font-heading text-2xl font-bold mt-4" data-testid="billing-cancel-title">Checkout cancelled</h1>
        <p className="text-sm text-[#AAB7C7] mt-2">No worries — you weren&apos;t charged. Pick a plan whenever you&apos;re ready.</p>
        <Link to="/app/admin" data-testid="cancel-back-to-admin"
          className="mt-6 inline-block px-6 py-3 rounded-lg bg-[#C7F500] hover:bg-[#D9FF27] text-[#071426] font-semibold">
          Back to Admin
        </Link>
      </div>
    </div>
  );
}
